import { useTrackersData } from 'pages/Trackers/trackersProvider';
import React from 'react';

export default function CollapsedViewToggle() {
  const { collapsedView, setCollapsedView } = useTrackersData();
  const handleChange = (event) => {
    setCollapsedView(event.target.value);
  };

  return (
    <div className="collapsedViewToggle" role="radiogroup" aria-label="Collapsed view">
      <label
        className={collapsedView === 'list' ? 'current' : undefined}
        htmlFor="collapsedListView"
      >
        <input
          className="visuallyHidden"
          type="radio"
          id="collapsedListView"
          name="list"
          value="list"
          checked={collapsedView === 'list'}
          onChange={handleChange}
        />
        <span>List</span>
      </label>
      <label
        className={collapsedView === 'flowchart' ? 'current' : undefined}
        htmlFor="collapsedFlowchartView"
      >
        <input
          className="visuallyHidden"
          type="radio"
          id="collapsedFlowchartView"
          name="flowchart"
          value="flowchart"
          checked={collapsedView === 'flowchart'}
          onChange={handleChange}
        />
        <span>Flowchart</span>
      </label>
    </div>
  );
}
